module.exports = __webpack_public_path__ + "static/img/iconshipinlan_shengyin_yichang_16_bai.f5fd9027.png";